$(function(){

  var owl_news = $(".grid-good-news.owl-carousel");

  if(owl_news.length)
  {
    owl_news.owlCarousel({
      nav: true,
      items: 4,
      loop: true,
      margin: 51,
      responsiveClass:true,
      responsive:{
          0:{
              margin: 0,
              items:1,
              autoHeight: true
          },
          590:{
              items:2,
              autoHeight: false
          },
          769:{
              items:3
          },
          1025:{
              items:4
          }
      }
    });
  }

  var cp_url;

  $('#shopify-section-featured-custom-collection-switcher').find('.grid__item a').on('click', function(e){
    e.preventDefault();

    $(this).parents('.grid').find('.grid__item').removeClass('active');
    $(this).parents('.grid__item').addClass('active');

    cp_url = $(this).attr('href');

    $.ajax({
       url: cp_url,
       type:'GET',
       success: function(data){
         $('.shopify-section-custom-product').html($(data).find('#shopify-section-product-template .page-width').html());
       }
    });

    jQuery.getJSON(cp_url, function(data) {
      // console.log(data);
      // console.log(data.product.title);
    });

    $('.ps-step2-title').removeAttr('disabled');
  });


  /* PERSONALIZE YOUR KIT BOX =============================================== */


  var rings_page = 1;
  var bracelets_page = 1;
  var earrings_page = 1;
  var necklaces_page = 1;

  var ps_kit = $('#ps-kit');
  var ps_panel = $('#ps-panel');

  var current_json;

  var product_id;
  var product_url;

  var product_title;
  var product_price;
  var product_description;
  var product_images = '';
  var product_option_list = '';
  var option1_list = '';
  var option2_list = '';
  var option3_list = '';

  var final_id;
  var mantra_id;
  var final_id;
  var final_id_list = [];

  if(rings_page === 1)
  {
    $.ajax({
      url: '/collections/rings/products.json',
      type: "get",
      dataType: "json",
      success: function (data) {
        var products = data.products;
        var grid__list = '';
        for(var r=0;r<products.length;r++)
        {
          // console.log(rings[r]);
          var product_id = products[r].id;
          var product_url = '/products/'+products[r].handle;
          var product_main_image = products[r].images[0].src;
          if(products[r].images[1] !== undefined)
          {
            var product_secondary_image = products[r].images[1].src;
          }else
          {
            var product_secondary_image = products[r].images[0].src;
          }
          var product_title = products[r].title;
          var product_tags = products[r].tags.join(',');
          var product_price = [];
          var product_from = '';

          for(var pp=0;pp<products[r].variants.length;pp++)
          {
            if(product_price.indexOf(products[r].variants[pp].price.split('.')[0]) === -1)
            {
              product_price.push(products[r].variants[pp].price.split('.')[0]);
            }
          }
          if(product_price.length > 1)
          {
            var pps_l = 10000;

            for(var pps=0;pps<product_price.length;pps++)
            {
              if(parseInt(product_price[pps])<pps_l)
              {
                pps_l = parseInt(product_price[pps]);
              }
            }
            product_from = 'from ';
            product_price = '$'+pps_l;
          }else
          {
            product_price = '$'+product_price[0];
          }

          grid__list += '<div class="grid__item" data-url="'+product_url+'" data-id="'+product_id+'"><div class="grid-product__content"><div class="grid-product__image-mask"><div class="grid__image-ratio grid__image-ratio--square lazyloaded" style="background-image: url('+product_main_image+')");"></div><div class="grid-product__secondary-image small--hide lazyloaded" style="background-image: url('+product_secondary_image+')");"></div><button class="add-to-kit">Add to kit</button></div><div class="grid-product__meta"><div class="grid-product__title">'+product_title+'</div><div class="grid-product__price">'+product_from+'<span class="money">'+product_price+'.00 USD</span></div><div class="grid-product__tags">'+product_tags+'</div></div></div></div>';
        }

        $('.tc-item.rings .grid__list').append(grid__list);

        $('#ps-tabs').find('.tc-item.rings').find('.tc-item-options').html('');

        var gemstones = [];
        var metals = [];

        $('#ps-tabs').find('.tc-item.rings').find('.grid__item').each(function(){
          if($(this).find('.grid-product__tags').length)
          {
            var divided_tags = $(this).find('.grid-product__tags').html().split(',');

            for(var a=0;a<divided_tags.length;a++)
            {
              if(divided_tags[a].indexOf('.') !== -1)
              {
                $(this).addClass(divided_tags[a].split('.').join('_'));

                if(divided_tags[a].split('.')[0] === 'gemstone')
                {
                  if (gemstones.indexOf(divided_tags[a].split('.')[1]) === -1)
                  {
                    gemstones.push(divided_tags[a].split('.')[1]);
                  }
                }else
                {
                  if (metals.indexOf(divided_tags[a].split('.')[1]) === -1)
                  {
                    metals.push(divided_tags[a].split('.')[1]);
                  }
                }
              }
            }
          }
        });

        if(gemstones.length !== 0)
        {
          var gemstone_options = '<option value="gemstone" selected id="no-gemstone">Gemstone</option>';
          for(var g=0;g<gemstones.length;g++)
          {
            var gemstone_text = gemstones[g].split('-').join(' ')
            gemstone_options += '<option value="'+gemstones[g]+'">'+gemstone_text+'</option>';
          }
          var gemstone_select = '<select id="gemstone-select" data-name="gemstone">'+gemstone_options+'</select>';

          $('#ps-tabs').find('.tc-item.rings').find('.tc-item-options').append(gemstone_select);
        }
        if(metals.length !== 0)
        {
          var metal_options = '<option value="metal-type" selected id="no-metal">Metal type</option>';
          for(var m=0;m<metals.length;m++)
          {
            var metal_text = metals[m].split('-').join(' ')
            metal_options += '<option value="'+metals[m]+'">'+metal_text+'</option>';
          }
          var metal_select = '<select id="metal-select" data-name="metal">>'+metal_options+'</select>';

          $('#ps-tabs').find('.tc-item.rings').find('.tc-item-options').append(metal_select);
        }
      },
      error: function(request, error) {
           console.log(arguments);
           console.log(" Can't do because: " + error);
      }
    });

    rings_page++;

    $.ajax({
      url: '/collections/rings/products.json?page=2',
      type: "get",
      dataType: "json",
      success: function (data) {
        var products = data.products;

        if(products.length === 0)
        {
          $('.tc-item.rings .load-more').hide();
        }
      },
      error: function(request, error) {
           console.log(arguments);
           console.log(" Can't do because: " + error);
      }
    });
  }
  if(bracelets_page === 1)
  {
    $.ajax({
      url: '/collections/bracelets/products.json',
      type: "get",
      dataType: "json",
      success: function (data) {
        var products = data.products;
        var grid__list = '';
        for(var r=0;r<products.length;r++)
        {
          // console.log(rings[r]);
          var product_id = products[r].id;
          var product_url = '/products/'+products[r].handle;
          var product_main_image = products[r].images[0].src;
          if(products[r].images[1] !== undefined)
          {
            var product_secondary_image = products[r].images[1].src;
          }else
          {
            var product_secondary_image = products[r].images[0].src;
          }
          var product_title = products[r].title;
          var product_tags = products[r].tags.join(',');
          var product_price = [];
          var product_from = '';

          for(var pp=0;pp<products[r].variants.length;pp++)
          {
            if(product_price.indexOf(products[r].variants[pp].price.split('.')[0]) === -1)
            {
              product_price.push(products[r].variants[pp].price.split('.')[0]);
            }
          }
          if(product_price.length > 1)
          {
            var pps_l = 10000;

            for(var pps=0;pps<product_price.length;pps++)
            {
              if(parseInt(product_price[pps])<pps_l)
              {
                pps_l = parseInt(product_price[pps]);
              }
            }
            product_from = 'from ';
            product_price = '$'+pps_l;
          }else
          {
            product_price = '$'+product_price[0];
          }

          grid__list += '<div class="grid__item" data-url="'+product_url+'" data-id="'+product_id+'"><div class="grid-product__content"><div class="grid-product__image-mask"><div class="grid__image-ratio grid__image-ratio--square lazyloaded" style="background-image: url('+product_main_image+')");"></div><div class="grid-product__secondary-image small--hide lazyloaded" style="background-image: url('+product_secondary_image+')");"></div><button class="add-to-kit">Add to kit</button></div><div class="grid-product__meta"><div class="grid-product__title">'+product_title+'</div><div class="grid-product__price">'+product_from+'<span class="money">'+product_price+'.00 USD</span></div><div class="grid-product__tags">'+product_tags+'</div></div></div></div>';
        }

        $('.tc-item.bracelets .grid__list').append(grid__list);

        $('#ps-tabs').find('.tc-item.bracelets').find('.tc-item-options').html('');

        var gemstones = [];
        var metals = [];

        $('#ps-tabs').find('.tc-item.bracelets').find('.grid__item').each(function(){
          if($(this).find('.grid-product__tags').length)
          {
            var divided_tags = $(this).find('.grid-product__tags').html().split(',');

            for(var a=0;a<divided_tags.length;a++)
            {
              if(divided_tags[a].indexOf('.') !== -1)
              {
                $(this).addClass(divided_tags[a].split('.').join('_'));

                if(divided_tags[a].split('.')[0] === 'gemstone')
                {
                  if (gemstones.indexOf(divided_tags[a].split('.')[1]) === -1)
                  {
                    gemstones.push(divided_tags[a].split('.')[1]);
                  }
                }else
                {
                  if (metals.indexOf(divided_tags[a].split('.')[1]) === -1)
                  {
                    metals.push(divided_tags[a].split('.')[1]);
                  }
                }
              }
            }
          }
        });

        if(gemstones.length !== 0)
        {
          var gemstone_options = '<option value="gemstone" selected id="no-gemstone">Gemstone</option>';
          for(var g=0;g<gemstones.length;g++)
          {
            var gemstone_text = gemstones[g].split('-').join(' ')
            gemstone_options += '<option value="'+gemstones[g]+'">'+gemstone_text+'</option>';
          }
          var gemstone_select = '<select id="gemstone-select" data-name="gemstone">'+gemstone_options+'</select>';

          $('#ps-tabs').find('.tc-item.bracelets').find('.tc-item-options').append(gemstone_select);
        }
        if(metals.length !== 0)
        {
          var metal_options = '<option value="metal-type" selected id="no-metal">Metal type</option>';
          for(var m=0;m<metals.length;m++)
          {
            var metal_text = metals[m].split('-').join(' ')
            metal_options += '<option value="'+metals[m]+'">'+metal_text+'</option>';
          }
          var metal_select = '<select id="metal-select" data-name="metal">>'+metal_options+'</select>';

          $('#ps-tabs').find('.tc-item.bracelets').find('.tc-item-options').append(metal_select);
        }
      },
      error: function(request, error) {
           console.log(arguments);
           console.log(" Can't do because: " + error);
      }
    });

    bracelets_page++;

    $.ajax({
      url: '/collections/bracelets/products.json?page=2',
      type: "get",
      dataType: "json",
      success: function (data) {
        var products = data.products;

        if(products.length === 0)
        {
          $('.tc-item.bracelets .load-more').hide();
        }
      },
      error: function(request, error) {
           console.log(arguments);
           console.log(" Can't do because: " + error);
      }
    });
  }
  if(earrings_page === 1)
  {
    $.ajax({
      url: '/collections/earrings/products.json',
      type: "get",
      dataType: "json",
      success: function (data) {
        var products = data.products;
        var grid__list = '';
        for(var r=0;r<products.length;r++)
        {
          // console.log(rings[r]);
          var product_id = products[r].id;
          var product_url = '/products/'+products[r].handle;
          var product_main_image = products[r].images[0].src;
          if(products[r].images[1] !== undefined)
          {
            var product_secondary_image = products[r].images[1].src;
          }else
          {
            var product_secondary_image = products[r].images[0].src;
          }
          var product_title = products[r].title;
          var product_tags = products[r].tags.join(',');
          var product_price = [];
          var product_from = '';

          for(var pp=0;pp<products[r].variants.length;pp++)
          {
            if(product_price.indexOf(products[r].variants[pp].price.split('.')[0]) === -1)
            {
              product_price.push(products[r].variants[pp].price.split('.')[0]);
            }
          }
          if(product_price.length > 1)
          {
            var pps_l = 10000;

            for(var pps=0;pps<product_price.length;pps++)
            {
              if(parseInt(product_price[pps])<pps_l)
              {
                pps_l = parseInt(product_price[pps]);
              }
            }
            product_from = 'from ';
            product_price = '$'+pps_l;
          }else
          {
            product_price = '$'+product_price[0];
          }

          grid__list += '<div class="grid__item" data-url="'+product_url+'" data-id="'+product_id+'"><div class="grid-product__content"><div class="grid-product__image-mask"><div class="grid__image-ratio grid__image-ratio--square lazyloaded" style="background-image: url('+product_main_image+')");"></div><div class="grid-product__secondary-image small--hide lazyloaded" style="background-image: url('+product_secondary_image+')");"></div><button class="add-to-kit">Add to kit</button></div><div class="grid-product__meta"><div class="grid-product__title">'+product_title+'</div><div class="grid-product__price">'+product_from+'<span class="money">'+product_price+'.00 USD</span></div><div class="grid-product__tags">'+product_tags+'</div></div></div></div>';
        }

        $('.tc-item.earrings .grid__list').append(grid__list);

        $('#ps-tabs').find('.tc-item.earrings').find('.tc-item-options').html('');

        var gemstones = [];
        var metals = [];

        $('#ps-tabs').find('.tc-item.earrings').find('.grid__item').each(function(){
          if($(this).find('.grid-product__tags').length)
          {
            var divided_tags = $(this).find('.grid-product__tags').html().split(',');

            for(var a=0;a<divided_tags.length;a++)
            {
              if(divided_tags[a].indexOf('.') !== -1)
              {
                $(this).addClass(divided_tags[a].split('.').join('_'));

                if(divided_tags[a].split('.')[0] === 'gemstone')
                {
                  if (gemstones.indexOf(divided_tags[a].split('.')[1]) === -1)
                  {
                    gemstones.push(divided_tags[a].split('.')[1]);
                  }
                }else
                {
                  if (metals.indexOf(divided_tags[a].split('.')[1]) === -1)
                  {
                    metals.push(divided_tags[a].split('.')[1]);
                  }
                }
              }
            }
          }
        });

        if(gemstones.length !== 0)
        {
          var gemstone_options = '<option value="gemstone" selected id="no-gemstone">Gemstone</option>';
          for(var g=0;g<gemstones.length;g++)
          {
            var gemstone_text = gemstones[g].split('-').join(' ')
            gemstone_options += '<option value="'+gemstones[g]+'">'+gemstone_text+'</option>';
          }
          var gemstone_select = '<select id="gemstone-select" data-name="gemstone">'+gemstone_options+'</select>';

          $('#ps-tabs').find('.tc-item.earrings').find('.tc-item-options').append(gemstone_select);
        }
        if(metals.length !== 0)
        {
          var metal_options = '<option value="metal-type" selected id="no-metal">Metal type</option>';
          for(var m=0;m<metals.length;m++)
          {
            var metal_text = metals[m].split('-').join(' ')
            metal_options += '<option value="'+metals[m]+'">'+metal_text+'</option>';
          }
          var metal_select = '<select id="metal-select" data-name="metal">>'+metal_options+'</select>';

          $('#ps-tabs').find('.tc-item.earrings').find('.tc-item-options').append(metal_select);
        }
      },
      error: function(request, error) {
           console.log(arguments);
           console.log(" Can't do because: " + error);
      }
    });

    earrings_page++;

    $.ajax({
      url: '/collections/earrings/products.json?page=2',
      type: "get",
      dataType: "json",
      success: function (data) {
        var products = data.products;

        if(products.length === 0)
        {
          $('.tc-item.earrings .load-more').hide();
        }
      },
      error: function(request, error) {
           console.log(arguments);
           console.log(" Can't do because: " + error);
      }
    });
  }
  if(necklaces_page === 1)
  {
    $.ajax({
      url: '/collections/necklaces/products.json',
      type: "get",
      dataType: "json",
      success: function (data) {
        var products = data.products;
        var grid__list = '';
        for(var r=0;r<products.length;r++)
        {
          // console.log(rings[r]);
          var product_id = products[r].id;
          var product_url = '/products/'+products[r].handle;
          var product_main_image = products[r].images[0].src;
          if(products[r].images[1] !== undefined)
          {
            var product_secondary_image = products[r].images[1].src;
          }else
          {
            var product_secondary_image = products[r].images[0].src;
          }
          var product_title = products[r].title;
          var product_tags = products[r].tags.join(',');
          var product_price = [];
          var product_from = '';

          for(var pp=0;pp<products[r].variants.length;pp++)
          {
            if(product_price.indexOf(products[r].variants[pp].price.split('.')[0]) === -1)
            {
              product_price.push(products[r].variants[pp].price.split('.')[0]);
            }
          }
          if(product_price.length > 1)
          {
            var pps_l = 10000;

            for(var pps=0;pps<product_price.length;pps++)
            {
              if(parseInt(product_price[pps])<pps_l)
              {
                pps_l = parseInt(product_price[pps]);
              }
            }
            product_from = 'from ';
            product_price = '$'+pps_l;
          }else
          {
            product_price = '$'+product_price[0];
          }

          grid__list += '<div class="grid__item" data-url="'+product_url+'" data-id="'+product_id+'"><div class="grid-product__content"><div class="grid-product__image-mask"><div class="grid__image-ratio grid__image-ratio--square lazyloaded" style="background-image: url('+product_main_image+')");"></div><div class="grid-product__secondary-image small--hide lazyloaded" style="background-image: url('+product_secondary_image+')");"></div><button class="add-to-kit">Add to kit</button></div><div class="grid-product__meta"><div class="grid-product__title">'+product_title+'</div><div class="grid-product__price">'+product_from+'<span class="money">'+product_price+'.00 USD</span></div><div class="grid-product__tags">'+product_tags+'</div></div></div></div>';
        }

        $('.tc-item.necklaces .grid__list').append(grid__list);

        $('#ps-tabs').find('.tc-item.necklaces').find('.tc-item-options').html('');

        var gemstones = [];
        var metals = [];

        $('#ps-tabs').find('.tc-item.necklaces').find('.grid__item').each(function(){
          if($(this).find('.grid-product__tags').length)
          {
            var divided_tags = $(this).find('.grid-product__tags').html().split(',');

            for(var a=0;a<divided_tags.length;a++)
            {
              if(divided_tags[a].indexOf('.') !== -1)
              {
                $(this).addClass(divided_tags[a].split('.').join('_'));

                if(divided_tags[a].split('.')[0] === 'gemstone')
                {
                  if (gemstones.indexOf(divided_tags[a].split('.')[1]) === -1)
                  {
                    gemstones.push(divided_tags[a].split('.')[1]);
                  }
                }else
                {
                  if (metals.indexOf(divided_tags[a].split('.')[1]) === -1)
                  {
                    metals.push(divided_tags[a].split('.')[1]);
                  }
                }
              }
            }
          }
        });

        if(gemstones.length !== 0)
        {
          var gemstone_options = '<option value="gemstone" selected id="no-gemstone">Gemstone</option>';
          for(var g=0;g<gemstones.length;g++)
          {
            var gemstone_text = gemstones[g].split('-').join(' ')
            gemstone_options += '<option value="'+gemstones[g]+'">'+gemstone_text+'</option>';
          }
          var gemstone_select = '<select id="gemstone-select" data-name="gemstone">'+gemstone_options+'</select>';

          $('#ps-tabs').find('.tc-item.necklaces').find('.tc-item-options').append(gemstone_select);
        }
        if(metals.length !== 0)
        {
          var metal_options = '<option value="metal-type" selected id="no-metal">Metal type</option>';
          for(var m=0;m<metals.length;m++)
          {
            var metal_text = metals[m].split('-').join(' ')
            metal_options += '<option value="'+metals[m]+'">'+metal_text+'</option>';
          }
          var metal_select = '<select id="metal-select" data-name="metal">>'+metal_options+'</select>';

          $('#ps-tabs').find('.tc-item.necklaces').find('.tc-item-options').append(metal_select);
        }
      },
      error: function(request, error) {
           console.log(arguments);
           console.log(" Can't do because: " + error);
      }
    });

    necklaces_page++;

    $.ajax({
      url: '/collections/necklaces/products.json?page=2',
      type: "get",
      dataType: "json",
      success: function (data) {
        var products = data.products;

        if(products.length === 0)
        {
          $('.tc-item.necklaces .load-more').hide();
        }
      },
      error: function(request, error) {
           console.log(arguments);
           console.log(" Can't do because: " + error);
      }
    });
  }

  $('.collect-my-kit').on('click', function(){
    $('html, body').animate({
        scrollTop: $(".steps-line").offset().top
    }, 1);
  });

  $('.load-more').on('click', function(){
    if($(this).parent().hasClass('rings'))
    {
      $.ajax({
        url: '/collections/rings/products.json?page='+rings_page,
        type: "get",
        dataType: "json",
        success: function (data) {
          var products = data.products;
          // console.log(products);

          var grid__list = '';
          for(var r=0;r<products.length;r++)
          {
            // console.log(rings[r]);
            var product_id = products[r].id;
            var product_url = '/products/'+products[r].handle;
            var product_main_image = products[r].images[0].src;
            if(products[r].images[1] !== undefined)
            {
              var product_secondary_image = products[r].images[1].src;
            }else
            {
              var product_secondary_image = products[r].images[0].src;
            }
            var product_title = products[r].title;
            var product_tags = products[r].tags.join(',');
            var product_price = [];
            var product_from = '';

            for(var pp=0;pp<products[r].variants.length;pp++)
            {
              if(product_price.indexOf(products[r].variants[pp].price.split('.')[0]) === -1)
              {
                product_price.push(products[r].variants[pp].price.split('.')[0]);
              }
            }
            if(product_price.length > 1)
            {
              var pps_l = 10000;

              for(var pps=0;pps<product_price.length;pps++)
              {
                if(parseInt(product_price[pps])<pps_l)
                {
                  pps_l = parseInt(product_price[pps]);
                }
              }
              product_from = 'from ';
              product_price = '$'+pps_l;
            }else
            {
              product_price = '$'+product_price[0];
            }

            grid__list += '<div class="grid__item" data-url="'+product_url+'" data-id="'+product_id+'"><div class="grid-product__content"><div class="grid-product__image-mask"><div class="grid__image-ratio grid__image-ratio--square lazyloaded" style="background-image: url('+product_main_image+')");"></div><div class="grid-product__secondary-image small--hide lazyloaded" style="background-image: url('+product_secondary_image+')");"></div><button class="add-to-kit">Add to kit</button></div><div class="grid-product__meta"><div class="grid-product__title">'+product_title+'</div><div class="grid-product__price">'+product_from+'<span class="money">'+product_price+'.00 USD</span></div><div class="grid-product__tags">'+product_tags+'</div></div></div></div>';
          }
          $('.tc-item.rings .grid__list').append(grid__list);

          rings_page++;

          $.ajax({
            url: '/collections/rings/products.json?page='+rings_page,
            type: "get",
            dataType: "json",
            success: function (data) {
              var products = data.products;

              if(products.length === 0)
              {
                $('.tc-item.rings .load-more').hide();
              }
            },
            error: function(request, error) {
                 console.log(arguments);
                 console.log(" Can't do because: " + error);
            }
          });

          $('#ps-tabs').find('.tc-item.rings').find('.tc-item-options').html('');

          var gemstones = [];
          var metals = [];

          $('#ps-tabs').find('.tc-item.rings').find('.grid__item').each(function(){
            if($(this).find('.grid-product__tags').length)
            {
              var divided_tags = $(this).find('.grid-product__tags').html().split(',');

              for(var a=0;a<divided_tags.length;a++)
              {
                if(divided_tags[a].indexOf('.') !== -1)
                {
                  $(this).addClass(divided_tags[a].split('.').join('_'));

                  if(divided_tags[a].split('.')[0] === 'gemstone')
                  {
                    if (gemstones.indexOf(divided_tags[a].split('.')[1]) === -1)
                    {
                      gemstones.push(divided_tags[a].split('.')[1]);
                    }
                  }else
                  {
                    if (metals.indexOf(divided_tags[a].split('.')[1]) === -1)
                    {
                      metals.push(divided_tags[a].split('.')[1]);
                    }
                  }
                }
              }
            }
          });

          if(gemstones.length !== 0)
          {
            var gemstone_options = '<option value="gemstone" selected id="no-gemstone">Gemstone</option>';
            for(var g=0;g<gemstones.length;g++)
            {
              var gemstone_text = gemstones[g].split('-').join(' ')
              gemstone_options += '<option value="'+gemstones[g]+'">'+gemstone_text+'</option>';
            }
            var gemstone_select = '<select id="gemstone-select" data-name="gemstone">'+gemstone_options+'</select>';

            $('#ps-tabs').find('.tc-item.rings').find('.tc-item-options').append(gemstone_select);
          }
          if(metals.length !== 0)
          {
            var metal_options = '<option value="metal-type" selected id="no-metal">Metal type</option>';
            for(var m=0;m<metals.length;m++)
            {
              var metal_text = metals[m].split('-').join(' ')
              metal_options += '<option value="'+metals[m]+'">'+metal_text+'</option>';
            }
            var metal_select = '<select id="metal-select" data-name="metal">>'+metal_options+'</select>';

            $('#ps-tabs').find('.tc-item.rings').find('.tc-item-options').append(metal_select);
          }
        },
        error: function(request, error) {
             console.log(arguments);
             console.log(" Can't do because: " + error);
        }
      });
    }else if($(this).parent().hasClass('bracelets'))
    {
      $.ajax({
        url: '/collections/bracelets/products.json?page='+bracelets_page,
        type: "get",
        dataType: "json",
        success: function (data) {
          var products = data.products;

          var grid__list = '';
          for(var r=0;r<products.length;r++)
          {
            // console.log(rings[r]);
            var product_id = products[r].id;
            var product_url = '/products/'+products[r].handle;
            var product_main_image = products[r].images[0].src;
            if(products[r].images[1] !== undefined)
            {
              var product_secondary_image = products[r].images[1].src;
            }else
            {
              var product_secondary_image = products[r].images[0].src;
            }
            var product_title = products[r].title;
            var product_tags = products[r].tags.join(',');
            var product_price = [];
            var product_from = '';

            for(var pp=0;pp<products[r].variants.length;pp++)
            {
              if(product_price.indexOf(products[r].variants[pp].price.split('.')[0]) === -1)
              {
                product_price.push(products[r].variants[pp].price.split('.')[0]);
              }
            }
            if(product_price.length > 1)
            {
              var pps_l = 10000;

              for(var pps=0;pps<product_price.length;pps++)
              {
                if(parseInt(product_price[pps])<pps_l)
                {
                  pps_l = parseInt(product_price[pps]);
                }
              }
              product_from = 'from ';
              product_price = '$'+pps_l;
            }else
            {
              product_price = '$'+product_price[0];
            }

            grid__list += '<div class="grid__item" data-url="'+product_url+'" data-id="'+product_id+'"><div class="grid-product__content"><div class="grid-product__image-mask"><div class="grid__image-ratio grid__image-ratio--square lazyloaded" style="background-image: url('+product_main_image+')");"></div><div class="grid-product__secondary-image small--hide lazyloaded" style="background-image: url('+product_secondary_image+')");"></div><button class="add-to-kit">Add to kit</button></div><div class="grid-product__meta"><div class="grid-product__title">'+product_title+'</div><div class="grid-product__price">'+product_from+'<span class="money">'+product_price+'.00 USD</span></div><div class="grid-product__tags">'+product_tags+'</div></div></div></div>';
          }
          $('.tc-item.bracelets .grid__list').append(grid__list);

          bracelets_page++;

          $.ajax({
            url: '/collections/bracelets/products.json?page='+bracelets_page,
            type: "get",
            dataType: "json",
            success: function (data) {
              var products = data.products;

              if(products.length === 0)
              {
                $('.tc-item.bracelets .load-more').hide();
              }
            },
            error: function(request, error) {
                 console.log(arguments);
                 console.log(" Can't do because: " + error);
            }
          });

          $('#ps-tabs').find('.tc-item.bracelets').find('.tc-item-options').html('');

          var gemstones = [];
          var metals = [];

          $('#ps-tabs').find('.tc-item.bracelets').find('.grid__item').each(function(){
            if($(this).find('.grid-product__tags').length)
            {
              var divided_tags = $(this).find('.grid-product__tags').html().split(',');

              for(var a=0;a<divided_tags.length;a++)
              {
                if(divided_tags[a].indexOf('.') !== -1)
                {
                  $(this).addClass(divided_tags[a].split('.').join('_'));

                  if(divided_tags[a].split('.')[0] === 'gemstone')
                  {
                    if (gemstones.indexOf(divided_tags[a].split('.')[1]) === -1)
                    {
                      gemstones.push(divided_tags[a].split('.')[1]);
                    }
                  }else
                  {
                    if (metals.indexOf(divided_tags[a].split('.')[1]) === -1)
                    {
                      metals.push(divided_tags[a].split('.')[1]);
                    }
                  }
                }
              }
            }
          });

          if(gemstones.length !== 0)
          {
            var gemstone_options = '<option value="gemstone" selected id="no-gemstone">Gemstone</option>';
            for(var g=0;g<gemstones.length;g++)
            {
              var gemstone_text = gemstones[g].split('-').join(' ')
              gemstone_options += '<option value="'+gemstones[g]+'">'+gemstone_text+'</option>';
            }
            var gemstone_select = '<select id="gemstone-select" data-name="gemstone">'+gemstone_options+'</select>';

            $('#ps-tabs').find('.tc-item.bracelets').find('.tc-item-options').append(gemstone_select);
          }
          if(metals.length !== 0)
          {
            var metal_options = '<option value="metal-type" selected id="no-metal">Metal type</option>';
            for(var m=0;m<metals.length;m++)
            {
              var metal_text = metals[m].split('-').join(' ')
              metal_options += '<option value="'+metals[m]+'">'+metal_text+'</option>';
            }
            var metal_select = '<select id="metal-select" data-name="metal">>'+metal_options+'</select>';

            $('#ps-tabs').find('.tc-item.bracelets').find('.tc-item-options').append(metal_select);
          }
        },
        error: function(request, error) {
             console.log(arguments);
             console.log(" Can't do because: " + error);
        }
      });
    }else if($(this).parent().hasClass('earrings'))
    {
      $.ajax({
        url: '/collections/earrings/products.json?page='+earrings_page,
        type: "get",
        dataType: "json",
        success: function (data) {
          var products = data.products;
          // console.log(products);

          var grid__list = '';
          for(var r=0;r<products.length;r++)
          {
            // console.log(rings[r]);
            var product_id = products[r].id;
            var product_url = '/products/'+products[r].handle;
            var product_main_image = products[r].images[0].src;
            if(products[r].images[1] !== undefined)
            {
              var product_secondary_image = products[r].images[1].src;
            }else
            {
              var product_secondary_image = products[r].images[0].src;
            }
            var product_title = products[r].title;
            var product_tags = products[r].tags.join(',');
            var product_price = [];
            var product_from = '';

            for(var pp=0;pp<products[r].variants.length;pp++)
            {
              if(product_price.indexOf(products[r].variants[pp].price.split('.')[0]) === -1)
              {
                product_price.push(products[r].variants[pp].price.split('.')[0]);
              }
            }
            if(product_price.length > 1)
            {
              var pps_l = 10000;

              for(var pps=0;pps<product_price.length;pps++)
              {
                if(parseInt(product_price[pps])<pps_l)
                {
                  pps_l = parseInt(product_price[pps]);
                }
              }
              product_from = 'from ';
              product_price = '$'+pps_l;
            }else
            {
              product_price = '$'+product_price[0];
            }

            grid__list += '<div class="grid__item" data-url="'+product_url+'" data-id="'+product_id+'"><div class="grid-product__content"><div class="grid-product__image-mask"><div class="grid__image-ratio grid__image-ratio--square lazyloaded" style="background-image: url('+product_main_image+')");"></div><div class="grid-product__secondary-image small--hide lazyloaded" style="background-image: url('+product_secondary_image+')");"></div><button class="add-to-kit">Add to kit</button></div><div class="grid-product__meta"><div class="grid-product__title">'+product_title+'</div><div class="grid-product__price">'+product_from+'<span class="money">'+product_price+'.00 USD</span></div><div class="grid-product__tags">'+product_tags+'</div></div></div></div>';
          }
          $('.tc-item.earrings .grid__list').append(grid__list);

          earrings_page++;

          $.ajax({
            url: '/collections/earrings/products.json?page='+earrings_page,
            type: "get",
            dataType: "json",
            success: function (data) {
              var products = data.products;

              if(products.length === 0)
              {
                $('.tc-item.earrings .load-more').hide();
              }
            },
            error: function(request, error) {
                 console.log(arguments);
                 console.log(" Can't do because: " + error);
            }
          });

          $('#ps-tabs').find('.tc-item.earrings').find('.tc-item-options').html('');

          var gemstones = [];
          var metals = [];

          $('#ps-tabs').find('.tc-item.earrings').find('.grid__item').each(function(){
            if($(this).find('.grid-product__tags').length)
            {
              var divided_tags = $(this).find('.grid-product__tags').html().split(',');

              for(var a=0;a<divided_tags.length;a++)
              {
                if(divided_tags[a].indexOf('.') !== -1)
                {
                  $(this).addClass(divided_tags[a].split('.').join('_'));

                  if(divided_tags[a].split('.')[0] === 'gemstone')
                  {
                    if (gemstones.indexOf(divided_tags[a].split('.')[1]) === -1)
                    {
                      gemstones.push(divided_tags[a].split('.')[1]);
                    }
                  }else
                  {
                    if (metals.indexOf(divided_tags[a].split('.')[1]) === -1)
                    {
                      metals.push(divided_tags[a].split('.')[1]);
                    }
                  }
                }
              }
            }
          });

          if(gemstones.length !== 0)
          {
            var gemstone_options = '<option value="gemstone" selected id="no-gemstone">Gemstone</option>';
            for(var g=0;g<gemstones.length;g++)
            {
              var gemstone_text = gemstones[g].split('-').join(' ')
              gemstone_options += '<option value="'+gemstones[g]+'">'+gemstone_text+'</option>';
            }
            var gemstone_select = '<select id="gemstone-select" data-name="gemstone">'+gemstone_options+'</select>';

            $('#ps-tabs').find('.tc-item.earrings').find('.tc-item-options').append(gemstone_select);
          }
          if(metals.length !== 0)
          {
            var metal_options = '<option value="metal-type" selected id="no-metal">Metal type</option>';
            for(var m=0;m<metals.length;m++)
            {
              var metal_text = metals[m].split('-').join(' ')
              metal_options += '<option value="'+metals[m]+'">'+metal_text+'</option>';
            }
            var metal_select = '<select id="metal-select" data-name="metal">>'+metal_options+'</select>';

            $('#ps-tabs').find('.tc-item.earrings').find('.tc-item-options').append(metal_select);
          }
        },
        error: function(request, error) {
             console.log(arguments);
             console.log(" Can't do because: " + error);
        }
      });
    }else if($(this).parent().hasClass('necklaces'))
    {
      $.ajax({
        url: '/collections/necklaces/products.json?page='+necklaces_page,
        type: "get",
        dataType: "json",
        success: function (data) {
          var products = data.products;
          // console.log(products);

          var grid__list = '';
          for(var r=0;r<products.length;r++)
          {
            // console.log(rings[r]);
            var product_id = products[r].id;
            var product_url = '/products/'+products[r].handle;
            var product_main_image = products[r].images[0].src;
            if(products[r].images[1] !== undefined)
            {
              var product_secondary_image = products[r].images[1].src;
            }else
            {
              var product_secondary_image = products[r].images[0].src;
            }
            var product_title = products[r].title;
            var product_tags = products[r].tags.join(',');
            var product_price = [];
            var product_from = '';

            for(var pp=0;pp<products[r].variants.length;pp++)
            {
              if(product_price.indexOf(products[r].variants[pp].price.split('.')[0]) === -1)
              {
                product_price.push(products[r].variants[pp].price.split('.')[0]);
              }
            }
            if(product_price.length > 1)
            {
              var pps_l = 10000;

              for(var pps=0;pps<product_price.length;pps++)
              {
                if(parseInt(product_price[pps])<pps_l)
                {
                  pps_l = parseInt(product_price[pps]);
                }
              }
              product_from = 'from ';
              product_price = '$'+pps_l;
            }else
            {
              product_price = '$'+product_price[0];
            }

            grid__list += '<div class="grid__item" data-url="'+product_url+'" data-id="'+product_id+'"><div class="grid-product__content"><div class="grid-product__image-mask"><div class="grid__image-ratio grid__image-ratio--square lazyloaded" style="background-image: url('+product_main_image+')");"></div><div class="grid-product__secondary-image small--hide lazyloaded" style="background-image: url('+product_secondary_image+')");"></div><button class="add-to-kit">Add to kit</button></div><div class="grid-product__meta"><div class="grid-product__title">'+product_title+'</div><div class="grid-product__price">'+product_from+'<span class="money">'+product_price+'.00 USD</span></div><div class="grid-product__tags">'+product_tags+'</div></div></div></div>';
          }
          $('.tc-item.necklaces .grid__list').append(grid__list);

          necklaces_page++;

          $.ajax({
            url: '/collections/necklaces/products.json?page='+necklaces_page,
            type: "get",
            dataType: "json",
            success: function (data) {
              var products = data.products;

              if(products.length === 0)
              {
                $('.tc-item.necklaces .load-more').hide();
              }
            },
            error: function(request, error) {
                 console.log(arguments);
                 console.log(" Can't do because: " + error);
            }
          });

          $('#ps-tabs').find('.tc-item.necklaces').find('.tc-item-options').html('');

          var gemstones = [];
          var metals = [];

          $('#ps-tabs').find('.tc-item.necklaces').find('.grid__item').each(function(){
            if($(this).find('.grid-product__tags').length)
            {
              var divided_tags = $(this).find('.grid-product__tags').html().split(',');

              for(var a=0;a<divided_tags.length;a++)
              {
                if(divided_tags[a].indexOf('.') !== -1)
                {
                  $(this).addClass(divided_tags[a].split('.').join('_'));

                  if(divided_tags[a].split('.')[0] === 'gemstone')
                  {
                    if (gemstones.indexOf(divided_tags[a].split('.')[1]) === -1)
                    {
                      gemstones.push(divided_tags[a].split('.')[1]);
                    }
                  }else
                  {
                    if (metals.indexOf(divided_tags[a].split('.')[1]) === -1)
                    {
                      metals.push(divided_tags[a].split('.')[1]);
                    }
                  }
                }
              }
            }
          });

          if(gemstones.length !== 0)
          {
            var gemstone_options = '<option value="gemstone" selected id="no-gemstone">Gemstone</option>';
            for(var g=0;g<gemstones.length;g++)
            {
              var gemstone_text = gemstones[g].split('-').join(' ')
              gemstone_options += '<option value="'+gemstones[g]+'">'+gemstone_text+'</option>';
            }
            var gemstone_select = '<select id="gemstone-select" data-name="gemstone">'+gemstone_options+'</select>';

            $('#ps-tabs').find('.tc-item.necklaces').find('.tc-item-options').append(gemstone_select);
          }
          if(metals.length !== 0)
          {
            var metal_options = '<option value="metal-type" selected id="no-metal">Metal type</option>';
            for(var m=0;m<metals.length;m++)
            {
              var metal_text = metals[m].split('-').join(' ')
              metal_options += '<option value="'+metals[m]+'">'+metal_text+'</option>';
            }
            var metal_select = '<select id="metal-select" data-name="metal">>'+metal_options+'</select>';

            $('#ps-tabs').find('.tc-item.necklaces').find('.tc-item-options').append(metal_select);
          }
        },
        error: function(request, error) {
             console.log(arguments);
             console.log(" Can't do because: " + error);
        }
      });
    }
  });

  var mantra_image;
  var mantra_id;
  $('#ps-step-first .next-step').on('click', function(e){
    if($(this).hasClass('disabled'))
    {
      e.preventDefault();
    }else {
      $('.steps-line').find('.step-p.active').removeClass('active');
      $('.steps-line').find('.step-p2').addClass('active');
      $('#ps-step-first').hide();
      $('#ps-step-second').show();
      $('.mantra-grid').hide();

      if(parseInt(ps_kit.find('.kit-subtotal span').attr('data-box-price'))<parseInt(ps_kit.find('.kit-subtotal span').text()))
      {
        $('#ps-panel').addClass('on-screen');
      }

      $('html, body').animate({
          scrollTop: $(".steps-line").offset().top
      }, 1);
    }

    // ps_panel.addClass('on-screen'); 
  });

  $('#ps-step-second .prev-step').on('click', function(e){
    if($(this).hasClass('disabled'))
    {
      e.preventDefault();
    }else {
      $('.steps-line').find('.step-p.active').removeClass('active');
      $('.steps-line').find('.step-p1').addClass('active');
      $('#ps-step-second').hide();
      $('#ps-step-first').show();
      $('.mantra-grid').show();

      ps_panel.removeClass('on-screen');
      $('#ps-panel .add-to-my-kit').attr('disabled', 'disabled');

      // ps_kit.find('.kit-subtotal span').text(parseInt(ps_kit.find('.kit-subtotal span').text()) - parseInt(ps_kit.find('.kit-subtotal span').attr('data-box-price')));
      // ps_panel.find('.add-to-my-kit span').text(parseInt(ps_panel.find('.add-to-my-kit span').text()) - parseInt(ps_panel.find('.add-to-my-kit span').attr('data-box-price')));
      // $('#ps-step-third button.add-to-cart span.atc-price').text(parseInt($('#ps-step-third button.add-to-cart span.atc-price').text()) - parseInt($('#ps-step-third button.add-to-cart span.atc-price').attr('data-box-price')));

      $('html, body').animate({
          scrollTop: $(".steps-line").offset().top
      }, 1);
    }
  });
  $('#ps-step-second .next-step').on('click', function(e){
    if($(this).hasClass('disabled'))
    {
      e.preventDefault();
    }else {
      $('.steps-line').find('.step-p.active').removeClass('active');
      $('.steps-line').find('.step-p3').addClass('active');
      $('#ps-step-second').hide();
      ps_panel.removeClass('on-screen');
      $('#ps-step-third').show();

      $('html, body').animate({
          scrollTop: $(".steps-line").offset().top
      }, 1);
    }
  });

  $('#ps-step-third .prev-step').on('click', function(e){
    if($(this).hasClass('disabled'))
    {
      e.preventDefault();
    }else {
      $('.steps-line').find('.step-p.active').removeClass('active');
      $('.steps-line').find('.step-p2').addClass('active');
      $('#ps-step-third').hide();
      ps_panel.addClass('on-screen');
      $('#ps-step-second').show();

      $('html, body').animate({
          scrollTop: $(".steps-line").offset().top
      }, 1);
    }
  });

  $('#ps-tabs .tabs-list li').on('click', function(){
    $('#ps-tabs .tabs-list li').removeClass('active');
    $(this).addClass('active');

    $('#ps-tabs .tabs-content .tc-item').removeClass('active');
    $('#ps-tabs .tabs-content .tc-item').eq($(this).index()).addClass('active');
  });

  var makeitpersonal_max = $('#makeitpersonal').attr('data-max');
  $('#makeitpersonal').on('keydown input', function(e){

    if($(this).val().length > makeitpersonal_max)
    {
      e.preventDefault();
    }else
    {
      var remaining = makeitpersonal_max - $(this).val().length;
      $('.characters-remaining span').text(remaining);
    }
  });



  $('.cp-mantras .cp-mantra').on('click', function(){
    mantra_image = $(this).find('.cp-mantra-image img').attr('src');
    var mantra_url = $(this).attr('data-url');
    var mantra_price = parseInt($(this).find('.cp-mantra-price').text())/100;

    jQuery.getJSON(mantra_url + '.js', function(mantra) {
      mantra_id = mantra.variants[0].id; 
    });

    $('.cp-mantras .cp-mantra').removeClass('active');
    $(this).addClass('active');


    ps_kit.find('.kit-images .box-image').html('<img src="'+mantra_image+'" alt="box-image">');
    ps_panel.find('.panel-items .pi-box').html('<img src="'+mantra_image+'" alt="box-image">');
    if(parseInt(ps_kit.find('.kit-subtotal span').text()) === 0)
    {
      ps_kit.find('.kit-subtotal span').text(mantra_price);
      ps_kit.find('.kit-subtotal span').attr('data-box-price', mantra_price);

      ps_panel.find('.add-to-my-kit span').text(mantra_price);
      ps_panel.find('.add-to-my-kit span').attr('data-box-price', mantra_price);

      $('#ps-step-third button.add-to-cart span.atc-price').text(mantra_price);
      $('#ps-step-third button.add-to-cart span.atc-price').attr('data-box-price', mantra_price);
    }else
    {
      ps_kit.find('.kit-subtotal span').text(mantra_price + parseInt(ps_kit.find('.kit-subtotal span').text()) - parseInt(ps_kit.find('.kit-subtotal span').attr('data-box-price')));
      ps_kit.find('.kit-subtotal span').attr('data-box-price', mantra_price);

      ps_panel.find('.add-to-my-kit span').text(mantra_price + parseInt(ps_panel.find('.add-to-my-kit span').text()) - parseInt(ps_panel.find('.add-to-my-kit span').attr('data-box-price')));
      ps_panel.find('.add-to-my-kit span').attr('data-box-price', mantra_price);

      $('#ps-step-third button.add-to-cart span.atc-price').text(mantra_price + parseInt($('#ps-step-third button.add-to-cart span.atc-price').text()) - parseInt($('#ps-step-third button.add-to-cart span.atc-price').attr('data-box-price')));
      $('#ps-step-third button.add-to-cart span.atc-price').attr('data-box-price', mantra_price);
    }

    $('#ps-step-first .next-step').removeAttr('disabled');
  });



  $('.cp-tiles-customize').on('click', function(){
    $('.cp-mantras .cp-mantra').eq($(this).parents('.cp-tile').index()).trigger('click');
    $('#ps-step-first .next-step').trigger('click');
  });

  $('body').on('click', '.grid__item .add-to-kit', function(){

    product_id = $(this).parents('.grid__item').attr('data-id');
    product_url = $(this).parents('.grid__item').attr('data-url');

    jQuery.getJSON(product_url + '.js', function(product) {
      current_json = product;

      $('#product-popup .popup-info .pp-title').text(product.title);
      $('#product-popup .popup-info .pp-price span').text(product.price/100);
      $('#product-popup .popup-info .pp-description').html(product.description);

      for(var po = 0;po<product.options.length;po++)
      {
        if(product.options.length === 1)
        {
          if(product.options[0].name !== 'Title')
          {
            product_option_list += '<div class="option"><select><option selected disabled>'+product.options[po].name+'</option></select></div>';
          }else
          {
            $('#product-popup .product-popup-content .popup-info .pp-bottom button[disabled]').removeAttr('disabled');
            final_id = product.variants[0].id;
            // console.log(final_id);
          }
        }else
        {
          product_option_list += '<div class="option"><select><option selected disabled>'+product.options[po].name+'</option></select></div>';
        }
      }
      $('.pp-options').append(product_option_list);
      product_option_list = '';

      if(product.options.length === 1)
      {
        if(product.options[0].name !== 'Title')
        {
          for(var po1 = 0;po1<product.options[0].values.length;po1++)
          {
            if(product.options[0].values[po1].indexOf('"'))
            {
              // var new_val = product.options[0].values[po1].split('"')[0];
              // option1_list += '<option value="'+new_val+'">'+product.options[0].values[po1]+'</option>';
              option1_list += '<option value="'+product.options[0].values[po1]+'">'+product.options[0].values[po1]+'</option>';
            }else
            {
              option1_list += '<option value="'+product.options[0].values[po1]+'">'+product.options[0].values[po1]+'</option>';
            }
          }

          $('.pp-options').find('.option').eq(0).find('select').append(option1_list);
        }else
        {
          final_id = product.variants[0].id;
        }
      }else if(product.options.length === 2)
      {
        for(var po1 = 0;po1<product.options[0].values.length;po1++)
        {
          option1_list += '<option value="'+product.options[0].values[po1]+'">'+product.options[0].values[po1]+'</option>';
        }
        for(var po2 = 0;po2<product.options[1].values.length;po2++)
        {
          option2_list += '<option value="'+product.options[1].values[po2]+'">'+product.options[1].values[po2]+'</option>';
        }
        $('.pp-options').find('.option').eq(0).find('select').append(option1_list);
        $('.pp-options').find('.option').eq(1).find('select').append(option2_list);
      }else if(product.options.length === 3)
      {

        for(var po1 = 0;po1<product.options[0].values.length;po1++)
        {
          option1_list += '<option value="'+product.options[0].values[po1]+'">'+product.options[0].values[po1]+'</option>';
        }
        for(var po2 = 0;po2<product.options[1].values.length;po2++)
        {
          option2_list += '<option value="'+product.options[1].values[po2]+'">'+product.options[1].values[po2]+'</option>';
        }
        for(var po3 = 0;po3<product.options[2].values.length;po3++)
        {
          option3_list += '<option value="'+product.options[2].values[po3]+'">'+product.options[2].values[po3]+'</option>';
        }
        $('.pp-options').find('.option').eq(0).find('select').append(option1_list);
        $('.pp-options').find('.option').eq(1).find('select').append(option2_list);
        $('.pp-options').find('.option').eq(2).find('select').append(option3_list);
      }        
      option1_list = '';
      option2_list = '';
      option3_list = '';

      $('.popup-images').append('<div class="featured-image"><img src="'+product.featured_image+'" alt="featured"></div>');

      for(var pi = 0;pi<product.images.length;pi++)
      {
        if(pi < 10)
        {
          product_images += '<div class="item"><img src="'+product.images[pi]+'" alt="'+product.title+'"></div>';
        }
      }

      $('.popup-images').append('<div class="pp-slider owl-carousel">'+product_images+'</div>');
      $('.popup-images').append('<div class="pp-thumbs owl-carousel">'+product_images+'</div>');
    
      var sync1 = $('.pp-slider'),
        sync2 = $('.pp-thumbs'),
        duration = 300,
        thumbs = 4;

        // Sync nav
        sync1.on('click', '.owl-next', function () {
            sync2.trigger('next.owl.carousel')
        });
        sync1.on('click', '.owl-prev', function () {
            sync2.trigger('prev.owl.carousel')
        });

        // Start Carousel
        sync1.owlCarousel({
            // rtl: true,
            // center: true,
            loop: true,
            items: 1,
            margin: 0,
            smartSpeed: 700,
            lazyLoad: true,
            nav: true,
            navText: ['', '']
        }).on('dragged.owl.carousel', function (e) {
            if (e.relatedTarget.state.direction == 'left') {
                sync2.trigger('next.owl.carousel')
            } else {
                sync2.trigger('prev.owl.carousel')
            }
        });


        sync2.owlCarousel({
            // rtl: true,
            loop: true,
            items: thumbs,
            margin: 10,
            smartSpeed: 700,
            nav: false,
            // center: true,
            responsive: {
                0: {
                    items: 4
                },
                768: {
                    items: 4
                }
            }
        }).on('click', '.owl-item', function () {
            var i = $(this).index() - (thumbs + 1);
            sync2.trigger('to.owl.carousel', [i, duration, true]);
            sync1.trigger('to.owl.carousel', [i, duration, true]);
        });

      product_images = '';
      $('.popup-images').addClass('show');
    });

    setTimeout(function(){
      if($('.pp-options .option').length === -1)
      {
        $('#product-popup button.pp-addtomykit').removeAttr('disabled');
      }
      $('body').addClass('active-product-popup');
    }, 500);



    



    // jQuery.ajax({
    //   type: 'POST',
    //   url: '/cart/add.js',
    //   data: {
    //       quantity: 1,
    //       id: final_id
    //   },
    //   dataType: 'json',           
    //   success: function() {
    //     jQuery.getJSON('/cart.js', function(cart) {
    //        // now have access to Shopify cart object
    //        console.log(cart);
    //     });
    //   },
    //   error: function(response) {
    //     console.log(response);
    //   }
    // });

    // jQuery.ajax({
    //   type: 'POST',
    //   url: '/cart/add.js',
    //   data: {
    //       quantity: 1,
    //       id: 31609032343617
    //   },
    //   dataType: 'json',           
    //   success: function() {
    //       // $ajax_loader.hide();
    //       // $checkbox.show();
    //       console.log('dasd');

    //       jQuery.getJSON('/cart.js', function(cart) {
    //        // now have access to Shopify cart object
    //        console.log(cart);
    //     } );
    //   },
    //   error: function(response) {
    //     console.log(response);
    //       // $ajax_loader.hide();
    //       // $add_to_cart.show();
    //     // alert('Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
    //   }
    // });
  });

  var popup_title;
  var popup_image;

  $('#product-popup button.pp-addtomykit').on('click', function(){

    if(final_id_list.indexOf(final_id) === -1)
    {
      final_id_list.push(final_id);

      popup_title = $(this).parents('.product-popup-content').find('.pp-title').text();
      popup_price = parseInt($(this).parents('.product-popup-content').find('.pp-price span').text());
      popup_image = $(this).parents('.product-popup-content').find('.featured-image img').attr('src');

      ps_kit.find('.kit-items').append('<div class="kit-item" data-id="'+final_id+'"><span class="ki-remove">✕</span><img src="'+popup_image+'" alt="'+popup_title+'"></div>');
      ps_kit.find('.kit-list').append('<li class="kit-list-item kit-list-item-product" data-id="'+final_id+'"><span class="kit-li-title">'+popup_title+'</span><span class="kit-li-price price">'+popup_price+'</span></li>');
      ps_kit.find('.kit-subtotal span').text(parseInt(ps_kit.find('.kit-subtotal span').html())+popup_price);

      ps_panel.find('.panel-items').append('<div class="panel-item" data-id="'+final_id+'"><div class="pi-remove">✕</div><img src="'+popup_image+'" alt="'+popup_title+'"></div>');
      ps_panel.find('.add-to-my-kit span').text(parseInt(ps_panel.find('.add-to-my-kit span').html())+popup_price);

      $('#ps-step-third button.add-to-cart .atc-price').text(parseInt($('#ps-step-third button.add-to-cart .atc-price').html())+popup_price);
    }else
    {
      // console.log("This item already exists");
    }

    $('body').removeClass('active-product-popup');
    $('#product-popup').find('.popup-images').html('');
    $('#product-popup').find('.pp-title').html('');
    $('#product-popup').find('.pp-price span').html('');
    $('#product-popup').find('.pp-description').html('');
    $('#product-popup').find('.pp-options').html('');
    $('#product-popup .product-popup-content .popup-info .pp-bottom button').attr('disabled', 'disabled');

    $('#ps-kit .kit-content .kit-complete[disabled]').removeAttr('disabled');
    $('#ps-panel .add-to-my-kit[disabled]').removeAttr('disabled');
    $('#ps-step-second .step-controls button.next-step.big[disabled]').removeAttr('disabled');

    if(final_id_list.length === 1)
    {
      ps_panel.addClass('on-screen'); 
    }
    if(final_id_list.length > 3)
    {
      $('#ps-step-second .grid__list .grid__item .grid-product__image-mask button.add-to-kit').attr('disabled', 'disabled');
    }
  });

  var remove_index;

  $('body').on('click', '.kit-item .ki-remove', function(){
    var remove_id = $(this).parent().attr('data-id');
    var remove_price = parseInt($(this).parents('#ps-kit').find('.kit-list .kit-list-item[data-id="'+remove_id+'"] .kit-li-price.price').text());

    $(this).parent().remove();
    $('#ps-kit').find('.kit-list .kit-list-item[data-id="'+remove_id+'"]').remove();
    $('#ps-kit').find('.kit-subtotal span').html(parseInt($('#ps-kit').find('.kit-subtotal span').html()) - remove_price);

    $('#ps-panel').find('.panel-items .panel-item[data-id="'+remove_id+'"]').remove();
    $('#ps-panel').find('.add-to-my-kit span').html(parseInt($('#ps-panel').find('.add-to-my-kit span').html()) - remove_price);

    $('#ps-step-third button.add-to-cart .atc-price').html(parseInt($('#ps-step-third button.add-to-cart .atc-price').html()) - remove_price);

    $('#ps-step-second .grid__list .grid__item .grid-product__image-mask button.add-to-kit').removeAttr('disabled');

    remove_index = final_id_list.indexOf(parseInt(remove_id));
    if (remove_index > -1) {
      final_id_list.splice(remove_index, 1);
    }

    if(final_id_list.length<1)
    {
      ps_panel.removeClass('on-screen'); 
      $('#ps-kit .kit-content .kit-complete').attr('disabled', 'disabled');
      $('#ps-panel .add-to-my-kit').attr('disabled', 'disabled');
      $('#ps-step-second .step-controls button.next-step.big').attr('disabled', 'disabled');
    }
  });
  $('body').on('click', '.panel-item .pi-remove', function(){
    var remove_id = $(this).parent().attr('data-id');
    var remove_price = parseInt($('#ps-kit').find('.kit-list .kit-list-item[data-id="'+remove_id+'"] .kit-li-price.price').text());

    $('#ps-kit').find('.kit-items .kit-item[data-id="'+remove_id+'"]').remove();
    $('#ps-kit').find('.kit-list .kit-list-item[data-id="'+remove_id+'"]').remove();
    $('#ps-kit').find('.kit-subtotal span').html(parseInt($('#ps-kit').find('.kit-subtotal span').html()) - remove_price);

    $(this).parent().remove();
    $('#ps-panel').find('.add-to-my-kit span').html(parseInt($('#ps-panel').find('.add-to-my-kit span').html()) - remove_price);

    $('#ps-step-third button.add-to-cart .atc-price').html(parseInt($('#ps-step-third button.add-to-cart .atc-price').html()) - remove_price);

    $('#ps-step-second .grid__list .grid__item .grid-product__image-mask button.add-to-kit').removeAttr('disabled');

    remove_index = final_id_list.indexOf(parseInt(remove_id));
    if (remove_index > -1) {
      final_id_list.splice(remove_index, 1);
    }

    if(final_id_list.length<1)
    {
      ps_panel.removeClass('on-screen'); 
      $('#ps-kit .kit-content .kit-complete').attr('disabled', 'disabled');
      $('#ps-panel .add-to-my-kit').attr('disabled', 'disabled');
      $('#ps-step-second .step-controls button.next-step.big').attr('disabled', 'disabled');
    }
  });
  var current_options;
  $('body').on('change', '#product-popup select', function() {
    current_options = [];

    $(this).parents('.pp-options').find('.option').each(function(){
      if($(this).find('select').val() !== null)
      {
        current_options.push($(this).find('select').val());
      }else
      {
        current_options = [];
        return false
      }
    });

    if(current_options.length > 0)
    {

      for(cj=0;cj<current_json.variants.length;cj++)
      {
        var split_json = current_json.variants[cj].options[0];
        split_json = split_json.split('"')[0];
        var split_array = [];
        split_array.push(split_json);

        var is_same = current_json.variants[cj].options.length == current_options.length && split_array.every(function(element, index) {
            return element === current_options[index]; 
        });

        if(is_same === true)
        {
          final_id = current_json.variants[cj].id;

          $('#product-popup .product-popup-content .popup-info .pp-price span').html(current_json.variants[cj].price/100);
          $('#product-popup .product-popup-content .popup-info .pp-bottom button[disabled]').removeAttr('disabled');
        
          return false
        }else
        {
          $('#product-popup .product-popup-content .popup-info .pp-bottom button').attr('disabled', 'disabled');
        }
      }
    }
  });


  // $(document).mouseup(function(e) 
  // {
  //     var product_popup = $('#product-popup-content');

  //     // if the target of the click isn't the container nor a descendant of the container
  //     if (!product_popup.is(e.target) && product_popup.has(e.target).length === 0) 
  //     {
  //       console.log(e.target);
  //       alert('outside click');
  //       $('body').removeClass('active-product-popup');
  //     }
  // });

  $(document).mouseup(function (e)
  {
    var container = $(".product-popup-content");

    if (!container.is(e.target) // if the target of the click isn't the container...
        && container.has(e.target).length === 0) // ... nor a descendant of the container
    {
      $('body').removeClass('active-product-popup');
      $('#product-popup').find('.popup-images').html('');
      $('#product-popup').find('.pp-title').html('');
      $('#product-popup').find('.pp-price span').html('');
      $('#product-popup').find('.pp-description').html('');
      $('#product-popup').find('.pp-options').html('');
      $('#product-popup .product-popup-content .popup-info .pp-bottom button').attr('disabled', 'disabled');
    }
  });

  var gemstone_chosen = '';
  var metal_chosen = '';

  var chosen_items_class = '.grid__item';

  $('body').on('change', '.tc-item-options select', function(){
    if($(this).attr("data-name") === 'gemstone')
    {
      if($(this).find(":selected").val() !== 'gemstone')
      {
        gemstone_chosen = '.gemstone_'+$(this).find(":selected").val();
      }else
      {
        gemstone_chosen = '';
      }

      if($(this).parent().find('select[data-name="metal"]').find(":selected").val() !== 'metal-type')
      {
        metal_chosen = '.metal_'+$(this).parent().find('select[data-name="metal"]').find(":selected").val();
      }else
      {
        metal_chosen = '';
      }

    }else
    {
      if($(this).find(":selected").val() !== 'metal-type')
      {
        metal_chosen = '.metal_'+$(this).find(":selected").val();
      }else
      {
        metal_chosen = '';
      }

      if($(this).parent().find('select[data-name="gemstone"]').find(":selected").val() !== 'gemstone')
      {
        gemstone_chosen = '.gemstone_'+$(this).parent().find('select[data-name="gemstone"]').find(":selected").val();
      }else
      {
        gemstone_chosen = '';
      }
    }

    $(this).parents('.tc-item').find('.grid__item').hide();
    $(this).parents('.tc-item').find('.grid__item'+gemstone_chosen+metal_chosen).show();

  });


  /* STEP 3 ========================================================== */

  $('#ps-kit .kit-content .kit-complete').on('click', function(){
    $('#ps-step-second .step-controls button.next-step.big').trigger('click');
  });
  $('#ps-panel .add-to-my-kit').on('click', function(){
    $('#ps-step-second .step-controls button.next-step.big').trigger('click');
  });

  var final_object = [];
  var final_object_remove = [];
  var makeitpersonal_val; 

  $('#ps-step-third .add-to-cart').on('click', function(){
    makeitpersonal_val = $('#ps-step-third #makeitpersonal').val();

    $('.steps-line').find('.step-p.active').removeClass('active');
    $('.steps-line').find('.step-p4').addClass('active');
    $('#ps-step-third').hide();
    $('#congratulations').show();

    $('html, body').animate({
          scrollTop: $(".steps-line").offset().top
    }, 1);

    final_object.push({quantity:1, id: mantra_id});
    final_object_remove.push({quantity:0, id: mantra_id});

    for(var fil = 0;fil<final_id_list.length;fil++)
    {
      final_object.push({quantity:1, id: final_id_list[fil]});
      final_object_remove.push({quantity:0, id: final_id_list[fil]});
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {items: final_object},
      // data: mantra_id,
      dataType: 'json',           
      success: function() {
        var drawer = new theme.CartDrawer();

        theme.cart.getCart().then(function(cart) {
          drawer.buildCart(cart, true);
        }.bind(this));

      },
      error: function(response) {
        console.log(response);
      }
    });

    setTimeout(function(){
      $('body').find('#CartContainer #CartSpecialInstructions').val(makeitpersonal_val);
      $('#congratulations button.start-a-new-kit').addClass('active');
    }, 3000);
  });


  $('#congratulations').find('button.start-a-new-kit').on('click', function(){
    $('#congratulations').hide();
    $('#congratulations button.start-a-new-kit').removeClass('active');
    $('.steps-line').find('.step-p.active').removeClass('active');
    final_id_list = [];
    final_object = [];
    final_object_remove = [];

    $('.cp-mantras .cp-mantra').removeClass('active');
    $('#ps-step-first .next-step').attr('disabled', 'disabled');

    ps_kit.find('.kit-images .box-image').html('');
    ps_kit.find('.kit-images .kit-items').html('');
    ps_kit.find('.kit-content .kit-list .kit-list-item-product').remove();
    ps_kit.find('.kit-content .kit-subtotal span').text('0');
    ps_kit.find('.kit-content .kit-subtotal span').attr('data-box-price', 0);
    ps_kit.find('.kit-content .kit-complete').attr('disabled', 'disabled');

    ps_panel.find('.panel-item.pi-box').html('');
    ps_panel.find('.panel-item:not(.pi-box)').remove();
    ps_panel.find('button.add-to-my-kit span').text('0');
    ps_panel.find('button.add-to-my-kit span').attr('data-box-price', 0);
    ps_panel.find('button.add-to-my-kit').attr('disabled', 'disabled');

    $('#ps-step-second .step-controls button.next-step.big').attr('disabled', 'disabled');
    $('#ps-tabs .tabs-list li:first-child').trigger('click');

    $('#ps-step-third form textarea').val('');
    $('#ps-step-third span.characters-remaining span').text('180');

    $('#ps-step-third .step-controls button.add-to-cart span.atc-price').text('0');
    $('#ps-step-third .step-controls button.add-to-cart span.atc-price').attr('data-box-price', 0);


    $('.steps-line').find('.step-p1').addClass('active');
    $('.mantra-grid').show();
    $('#ps-step-first').show();

    $('html, body').animate({
          scrollTop: $(".steps-line").offset().top
    }, 1);

  });


  /* PERSONALIZE YOUR KIT BOX =============================================== */
});
